import { Spinner } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

export const Loading: React.VFC = () => {
  return (
    <div className={styles['loading']} data-testid="offers_history_loading">
      <Spinner size={24} />
    </div>
  );
};
